
import { useContext, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { Typography, Card, CardMedia, CardContent, CardActions, Button, Box, Grid, Stack } from "@mui/material";
import "./publicforumcard.scss";
import CircleIcon from '@mui/icons-material/Circle';
import PublicForumImg from "../../../Assets/icon_setting/public_forum.png"
import WorkGroupAction from "../../../Components/WorkGroup/WorkGroupAction";
import WorkGroupView from "../../../Components/WorkGroup/WorkGroupView";
import { useGetWorkGroupById } from "../../../Hooks/useGetWorkGroupById";
import PublicForumAction from "../../../Components/PublicForum/PublicForumAction"
import { startOfDay } from "date-fns";
import moment from "moment";
import { useNavigate } from "react-router-dom";


export default function PublicForumCard({ item, setRefetch, handleNavigateQuestionAndAnswer }) {
    const { t } = useContext(AuthContext);

    return (

        <Box className="public-forum-card">
            <Stack direction="column" spacing={3} onClick={() => handleNavigateQuestionAndAnswer(item?._id)} >
                <Stack direction={'row'} justifyContent={"center"} className="card-cover">
                    <img src={PublicForumImg} alt="Public Forum Icon" className="icon" />
                </Stack>
                <Stack direction={"column"} justifyContent="flex-start" spacing={1.5} className="card-content">
                    <Stack direction={"column"} spacing={1.5}>
                        <Typography variant="h6" className="title">
                            {item?.publicForumTitle}
                        </Typography>
                        <Stack direction="column" spacing={0.5}>
                            <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={0.8}>
                                <Typography className="numbers-ballot">{t("thead_municipality_district")}:</Typography>
                                <Typography className="numbers-ballot">{item?.districtMunicipalityId?.district_municipality_name_kh || item?.summary_info?.districtMunicipalityId?.district_municipality_name_en}</Typography>
                            </Stack>
                            <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={0.8}>
                                <Typography className="numbers-ballot" >{t("thead_date")}:</Typography>
                                {
                                    item?.startDate === item?.endDate ? (
                                        <Typography className="numbers-ballot" >{moment(item?.startDate).format("DD-MM-YYYY")}</Typography>
                                    ) : (
                                        <Typography className="numbers-ballot" >{moment(item?.startDate).format("DD-MM-YYYY")} {t("thead_to")} {moment(item?.endDate).format("DD-MM-YYYY")}</Typography>
                                    )
                                }
                            </Stack>
                            <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={0.8}>
                                <Typography className="numbers-ballot" >{t("thead_description")}:</Typography>
                                <Typography className="numbers-ballot" >{item?.publicForumDescription}</Typography>
                            </Stack>
                        </Stack>
                    </Stack>

                </Stack>

            </Stack >
            <Stack className="card-content" alignItems={"flex-start"}>
                <PublicForumAction
                    item={item}
                    setRefetch={setRefetch}
                />
            </Stack>
        </Box>
    );

}